export default {
  getQueueMissed: state =>  {
    return state.queueMissed
  }
}